var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", { attrs: { "data-ci": "login-page-title" } }, [
        _c("strong", {
          directives: [
            {
              name: "t",
              rawName: "v-t",
              value: _vm.langRoot + ".title",
              expression: "`${langRoot}.title`"
            }
          ]
        })
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      this.$route.query.error
        ? _c("page-notification", {
            attrs: {
              "data-ci": "login-error-notification",
              type: "error",
              messages: [
                _vm.$t(_vm.langRoot + ".genericError.title"),
                _vm.$t(_vm.langRoot + ".genericError.message")
              ]
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isCookiesEnabled
        ? _c("page-notification", {
            attrs: {
              type: "error",
              messages: [_vm.$t(_vm.langRoot + ".noCookieMsg")],
              "data-ci": "login-error-notification"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("p", {
        directives: [
          {
            name: "t",
            rawName: "v-t",
            value: _vm.langRoot + ".usernameAndPasswordInstruction",
            expression: "`${langRoot}.usernameAndPasswordInstruction`"
          }
        ]
      }),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("p", {
        directives: [
          {
            name: "t",
            rawName: "v-t",
            value: _vm.langRoot + ".requiredHelper",
            expression: "`${langRoot}.requiredHelper`"
          }
        ],
        staticClass: "login__required-helper"
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "login__form",
          attrs: {
            name: "loginForm",
            action: _vm.loginUrl,
            method: "POST",
            autocomplete: "off"
          },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.login.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "field login__field is-horizontal" }, [
            _c("div", { staticClass: "field-label is-normal" }, [
              _c("label", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: _vm.langRoot + ".loginForm.username",
                    expression: "`${langRoot}.loginForm.username`"
                  }
                ],
                staticClass: "label",
                attrs: { for: "username-input" }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.data.username,
                        expression: "form.data.username"
                      }
                    ],
                    ref: "username",
                    staticClass: "input",
                    class: {
                      login__input: !_vm.form.field.username.hasError,
                      "login__input--error": _vm.form.field.username.hasError
                    },
                    attrs: {
                      id: "username-input",
                      name: "username",
                      type: "text",
                      "data-ci": "username-input",
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.form.data.username },
                    on: {
                      change: function($event) {
                        return _vm.$trackEvent(_vm.pageTag, "enter_username")
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form.data, "username", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field login__field is-horizontal" }, [
            _c("div", { staticClass: "field-label is-normal" }, [
              _c("label", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: _vm.langRoot + ".loginForm.password",
                    expression: "`${langRoot}.loginForm.password`"
                  }
                ],
                staticClass: "label",
                attrs: { for: "password-input" }
              })
            ]),
            _vm._v(" "),
            _c("input", {
              staticStyle: { display: "none" },
              attrs: { type: "text" }
            }),
            _vm._v(" "),
            _c("input", {
              staticStyle: { display: "none" },
              attrs: { type: "password" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.data.password,
                        expression: "form.data.password"
                      }
                    ],
                    ref: "password",
                    staticClass: "input login__input",
                    class: {
                      "login__input--error": _vm.form.field.password.hasError
                    },
                    attrs: {
                      id: "password-input",
                      name: "password",
                      type: "password",
                      "data-ci": "password-input"
                    },
                    domProps: { value: _vm.form.data.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form.data, "password", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "i18n",
            {
              attrs: {
                path: _vm.langRoot + ".forgottenUserOrPassword.question",
                tag: "span"
              }
            },
            [
              _c("a", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: _vm.langRoot + ".forgottenUserOrPassword.username",
                    expression: "`${langRoot}.forgottenUserOrPassword.username`"
                  }
                ],
                attrs: {
                  href: "#",
                  place: "usernameLink",
                  "data-ci": "recover-username-link"
                },
                on: {
                  click: function($event) {
                    return _vm.forgottenUsername()
                  }
                }
              }),
              _vm._v(" "),
              _c("a", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: _vm.langRoot + ".forgottenUserOrPassword.password",
                    expression: "`${langRoot}.forgottenUserOrPassword.password`"
                  }
                ],
                attrs: {
                  href: "#",
                  place: "passwordLink",
                  "data-ci": "recover-password-link"
                },
                on: {
                  click: function($event) {
                    return _vm.forgottenPassword()
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _vm.getInvitation()
            ? _c("div", [
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _vm.form.feedback
                  ? _c(
                      "div",
                      {
                        staticClass: "login__form-feedback",
                        attrs: { "data-ci": "login-feedback" }
                      },
                      [
                        _c("i8-icon", {
                          attrs: { colour: "gold", icon: "circle-error-solid" }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.form.feedback))])
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "level login__footer" }, [
            _c("div", { staticClass: "level-left level-item" }, [
              !_vm.getInvitation() && _vm.form.feedback
                ? _c(
                    "div",
                    {
                      staticClass: "login__form-feedback",
                      attrs: { "data-ci": "login-feedback" }
                    },
                    [
                      _c("i8-icon", {
                        attrs: { colour: "gold", icon: "circle-error-solid" }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.form.feedback))])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.getInvitation()
                ? _c("button", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: _vm.langRoot + ".cancelBtn",
                        expression: "`${langRoot}.cancelBtn`"
                      }
                    ],
                    staticClass: "btn ghost",
                    attrs: { type: "button", "data-ci": "login-button" },
                    on: {
                      click: function($event) {
                        return _vm.goBackToRegistration()
                      }
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "level-right level-item" }, [
              _c("button", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: _vm.langRoot + ".submitBtn",
                    expression: "`${langRoot}.submitBtn`"
                  }
                ],
                staticClass: "btn primary",
                attrs: { type: "submit", "data-ci": "login-button" }
              })
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed8d8bf0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed8d8bf0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./login/Components/LoginForm.vue
// module id = 37U7
// module chunks = 1